import { useState } from "react";

const RecipeIngredientItem = ({
  ingredient,
  updateQuantity,
  updateMeasurement,
  removeRecipeIngredient,
  measurements,
}) => {
  const [selectedMeasurement, setSelectedMeasurement] = useState("");

  const setQuantity = (value) => {
    console.log("RecipeIngredientItem updating quantity to ", value);
    updateQuantity(ingredient, value);
  };

  const setQuantityValidate = (value) => {
    console.log("RecipeIngredientItem set quantity validate to ", value);
    const quantityValidated = parseFloat(value);
    updateQuantity(ingredient, quantityValidated);
  };

  const handleSelectedMeasurement = (event) => {
    const measurementId = event.target.value;
    console.log("RecipeIngredientItem updating measurement to ", measurementId);
    updateMeasurement(ingredient, measurementId);
    setSelectedMeasurement(measurementId);
  };

  return (
    <li>
      <div className="flex flex-wrap items-center gap-2 bg-teal-50 border border-teal-100 rounded-md px-3 py-2">
        <label className="text-sm text-stone-800">{ingredient?.name}</label>
        <input
          type="text"
          className="w-14 border border-stone-300 rounded px-2 py-1 text-sm"
          onChange={(e) => setQuantity(e.target.value)}
          onBlur={(e) => setQuantityValidate(e.target.value)}
          value={ingredient?.quantity}
          required
        ></input>
        {ingredient?.isMeasured && (
          <select
            id="dropdown"
            value={selectedMeasurement}
            onChange={handleSelectedMeasurement}
            className="border border-stone-300 rounded px-2 py-1 text-sm bg-white"
          >
            <option value="" disabled>
              Measurements
            </option>
            {measurements.map((m) => (
              <option key={m.description} value={m.sid}>
                {m.description}
              </option>
            ))}
          </select>
        )}
        <button
          type="button"
          className="ml-auto h-6 w-6 shrink-0 inline-flex items-center justify-center rounded-full bg-white text-stone-500 hover:bg-stone-200 hover:text-stone-700 text-xs font-bold"
          onClick={() => removeRecipeIngredient(ingredient)}
        >
          x
        </button>
      </div>
    </li>
  );
};

export default RecipeIngredientItem;
